<template>
  <div id="icon-packs">
    <div class="row roomy">
      <div
        v-for="pack in iconPacks"
        :key="pack.name"
        class="all-icon-packs-listing column-12 tablet:column-6 laptop:column-4"
        style="--card-min-height: var(--icon-pack-card-min-height, 12rem)"
      >
        <site-link
          :to="$pack({ name: pack.name })"
          :class="`card header icon-pack-card icon-pack-card-${pack.name}`"
          :style="`
            background-clip: padding-box;
            background-image: url('/images/icons/packs/${pack.name}/${pack.thumbImage}');
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
          `"
        >
          <span class="sr-only">{{ pack.label }}</span>
        </site-link>
      </div>
    </div>
  </div>
</template>

<script>
  import { getIconPacks } from 'app/views/search/collections.js'

  export default {
    name: 'IconPacksList',

    computed: {
      iconPacks() {
        const notHidden = (pack) => pack.status === 'released' || pack.status === 'prereleased'

        // At this time, we are intentionally showing the version 7 icon packs so
        // we can tease, coerce, market to, and gingerlly waggle a come-hitherto finger
        // at our lovely users. They want it...we got it.
        return getIconPacks(7).filter(notHidden)
      }
    },

    methods: {
      getPackIcon(pack) {
        return `${pack.iconPrefix} fa-${pack.iconName}`
      }
    }
  }
</script>
